import React from 'react';

import Heading from '../components/Headers/Heading';
import Art from '../components/Misc/Art';
import illustration from '../assets/images/art_1.png';
import CareersContent from '../components/TextContent/CareersContent';
import CareerSection from '../components/AboutComponents/CareerSection';
import StudentCareerSection from '../components/AboutComponents/StudentCareerSection';

import careersHeaderImage from '../assets/images/careers-header.jpg';
import careersImage1 from '../assets/images/careers-1.jpg';
import careersImage2 from '../assets/images/careers-2.jpg';
import careersImage3 from '../assets/images/careers-3.jpg';
import careersImage4 from '../assets/images/careers-4.jpg';

function About() {
    return (
        <div className="careers-page">
            <div className="page-header position-relative">
                <Heading
                    heading={<h1>Careers</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Work with a multidisciplinary team building meaningful technology for learning and training."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />

                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={careersHeaderImage} alt="careers-header" />
                    </div>
                    <Art art={illustration} type="1" />
                </div>

            </div>

            <CareersContent />
            <br /><br />
                <div className="single-image-wrapper">
                <div className="single-image">
                    <img src={careersImage3} alt="" />
                </div>
                <div className="single-image">
                    <img src={careersImage4} alt="" />
                </div>
            </div><br /><br />
            <br /><br /><br /><br /><br />  
            <CareerSection />
            <StudentCareerSection />

            <br /><br />  
            <div className="single-image-wrapper">
                <div className="single-image">
                    <img src={careersImage1} alt="" />
                </div>
                <div className="single-image">
                    <img src={careersImage2} alt="" />
                </div>
            </div><br /><br />

            {/*
            <div className="page-header-bottom">
                <div className="single-image">
                    <img src={careersFooterImage} alt="careers-footer" />
                </div>
                <Art art={illustration} type="1" />
            </div>
            */}
        </div>
    );
}

export default About;
